import React, {
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react';
import classNames from 'classnames';

import ErrorMessage from 'common/components/ErrorMessage';

import styles from './styles.module.scss';

export interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string,
  error?: string,
  required?: boolean,
}

const Input = forwardRef(({
  name,
  label,
  error,
  required,
  disabled,
  className,
  ...props
}: IInputProps, ref: ForwardedRef<HTMLInputElement>) => (
  <div
    className={classNames(
      styles.wrapper,
      'common-components-Input__wrapper',
      className,
      {
        [styles.disabled]: disabled,
        'common-components-Input__wrapper--disabled': disabled,
      },
    )}
  >
    {label && (
      <div className={classNames(styles.label, 'common-components-Input__label')}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </div>
    )}
    <input
      {...props}
      ref={ref}
      className={classNames(
        styles.input,
        'common-components-Input__input',
        {
          [styles.error]: error,
          'common-components-Input__input--error': error,
        },
      )}
      name={name}
      disabled={disabled}
    />
    {error && <ErrorMessage text={error} />}
  </div>
));

export default Input;
